import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProLayout from '../layout/ProLayout';
import VouchersModal from '../modals/VouchersModal';

const VouchersPage = () => {
  const navigate = useNavigate();

  return (
    <ProLayout title="Bons">
      <div className="modal-as-page h-full">
        <VouchersModal
          isOpen={true}
          onClose={() => navigate('/optician-dashboard')}
        />
      </div>
    </ProLayout>
  );
};

export default VouchersPage;
